import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 32,
    orderStatus: 1,
    serviceOption: "",
    servicePriority: 0,
    sampleAmount: 5,
    additionalComments: "",
    tableData: [],
  },
};

//creates the user slice with the initial state and actions
const freeTrialSlice = createSlice({
  name: "freetrial",
  initialState,
  reducers: {
    //action creators
    initializeFreeTrialData(state, action) {
      for (let i = 0; i < state.data.sampleAmount; i++) {
        const newObj = {
          id: i + 1,
          dName: "",
          dConc: 0,
          dType: "",
          pcrSize: "",
          library: "",
          pName: "",
          pConc: 0,
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    setFreeTrialSampleAmount(state,action){
      state.data.sampleAmount = 10
      for (let i = 5; i <= 9; i++) {
        const newObj = {
          id: i + 1,
          dName: "",
          dConc: 0,
          dType: "",
          pcrSize: "",
          library: "",
          pName: "",
          pConc: 0,
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return
    },
    resetFreeTrialState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetFreeTrialPage(state, action) {
      state.page = action.payload;
      return;
    },
    setFreeTrialServiceOption(state, action) {
      state.data.serviceOption = action.payload;
      return;
    },
    setFreeTrialServicePriority(state, action) {
      state.data.servicePriority = parseInt(action.payload);
      return;
    },
    editFreeTrialRow(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.tableData];

      if (property === "dName" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert("Only special characters allowed: hyphen( - ) and underscore( _ ).");
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    increaseFreeTrialConcentration(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] += 1;
    },
    decreaseFreeTrialConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    editFreeTrialComments(state, action) {
      state.data.additionalComments = action.payload;
    },
    clearFreeTrialSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    freeTrialPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    freeTrialNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    setFreeTrialOrderNumber: (state, action) => {
      state.data.orderNumber = action.payload
    }
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return [];
    });
  },
});

export const {
  initializeFreeTrialData,
  setFreeTrialSampleAmount,
  resetFreeTrialState,
  resetFreeTrialPage,
  setFreeTrialServiceOption,
  setFreeTrialServicePriority,
  editFreeTrialRow,
  increaseFreeTrialConcentration,
  decreaseFreeTrialConcentration,
  editFreeTrialComments,
  clearFreeTrialSelect,
  freeTrialNextStep,
  setFreeTrialOrderNumber,
  freeTrialPrevStep,
} = freeTrialSlice.actions;
export const freeTrialReducer = freeTrialSlice.reducer;
